function cov_11wxv0t7j7() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetManifest.tsx";
  var hash = "fed76e52d04b1abe45093fbea2c8f6b4cc39a9b0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetManifest.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 42
        },
        end: {
          line: 149,
          column: 1
        }
      },
      "1": {
        start: {
          line: 153,
          column: 44
        },
        end: {
          line: 163,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fed76e52d04b1abe45093fbea2c8f6b4cc39a9b0"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_11wxv0t7j7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_11wxv0t7j7();

/**
 * Source of truth for Icons.
 * Adding an Icon here will kick off typechecking that will ensure
 * that an Icon is added to the "Spritesheet" that is included on
 * different pages.
 *
 */
export var SPRITESHEET_ICONS_MANIFEST = (cov_11wxv0t7j7().s[0]++, {
  '360': true,
  '360-2': true,
  'arrow-down': true,
  'arrow-left': true,
  'arrow-right': true,
  'arrow-up': true,
  avatar: true,
  'avatar-filled': true,
  bathroom: true,
  'bathroom-filled': true,
  'bathroom-version-two': true,
  'bathroom-version-two-filled': true,
  bedroom: true,
  'bedroom-filled': true,
  chat: true,
  'chat-inactive': true,
  'chat-2': true,
  'chat-2-filled': true,
  checkmark: true,
  'chevron-down': true,
  'chevron-left': true,
  'chevron-right': true,
  'chevron-up': true,
  close: true,
  date: true,
  'date-filled': true,
  'date-add': true,
  'date-add-filled': true,
  'date-checked': true,
  'date-checked-filled': true,
  'date-subtract': true,
  'date-subtract-filled': true,
  'document-check': true,
  'document-check-filled': true,
  door: true,
  'door-filled': true,
  'double-chevron': true,
  'double-move': true,
  'early-access': true,
  edit: true,
  'edit-filled': true,
  email: true,
  'email-filled': true,
  equal: true,
  expertise: true,
  favorite: true,
  'favorite-filled': true,
  filter: true,
  garage: true,
  'garage-filled': true,
  geo: true,
  'geo-filled': true,
  home: true,
  'home-filled': true,
  'home-chat': true,
  'home-chat-filled': true,
  'home-cost': true,
  'home-cost-filled': true,
  'home-location': true,
  'home-location-filled': true,
  info: true,
  'info-filled': true,
  invite: true,
  'invite-filled': true,
  jewel: true,
  levels: true,
  'levels-filled': true,
  list: true,
  location: true,
  'location-pin': true,
  'location-pin-filled': true,
  'location-pin-home': true,
  'location-pin-home-filled': true,
  lock: true,
  'lock-filled': true,
  logo: true,
  map: true,
  menu: true,
  minus: true,
  money: true,
  move: true,
  'move-filled': true,
  'multiple-offers': true,
  'multiple-ofers-filled': true,
  neighborhood: true,
  'neighborhood-filled': true,
  "new": true,
  'new-construction': true,
  'new-tab': true,
  'new-tab-filled': true,
  notification: true,
  obo: true,
  offer: true,
  'offer-inactive': true,
  open: true,
  pdf: true,
  phone: true,
  'phone-filled': true,
  placeholder: true,
  plus: true,
  popular: true,
  question: true,
  rate: true,
  refresh: true,
  'refresh-filled': true,
  reset: true,
  search: true,
  'search-filled': true,
  see: true,
  'see-filled': true,
  'see-hidden': true,
  share: true,
  'share-filled': true,
  shower: true,
  'shower-filled': true,
  sign: true,
  'sign-filled': true,
  sink: true,
  'sink-filled': true,
  'sink-version-two': true,
  'sink-version-two-filled': true,
  sliders: true,
  'sliders-filled': true,
  'square-feet': true,
  'square-feet-filled': true,
  star: true,
  'star-filled': true,
  telephone: true,
  trash: true,
  'trash-filled': true,
  'unlock-left': true,
  'unlock-left-filled': true,
  'unlock-right': true,
  'unlock-right-filled': true,
  video: true,
  'video-filled': true,
  warning: true,
  // Old Sprite Sheets below: please update to new designs and naming
  opendoor: true,
  'progress-bar': true
});
export var SIZE_SPECIFIC_ICONS_MANIFEST = (cov_11wxv0t7j7().s[1]++, {
  'chevron-down-12': true,
  'chevron-down-16': true,
  'chevron-left-12': true,
  'chevron-left-16': true,
  'chevron-up-12': true,
  'chevron-up-16': true,
  'chevron-right-12': true,
  'chevron-right-16': true,
  'close-16': true
});